namespace RedBullMOBILE360.CVM {
    export interface CvmSegmentForm {
        Title: Serenity.StringEditor;
        OfferId: Serenity.StringEditor;
        CampaignId: Serenity.LookupEditor;
        Criteria: Serenity.LookupEditor;
        IsEnabled: Serenity.BooleanEditor;
        ActionType: Serenity.StringEditor;
    }

    export class CvmSegmentForm extends Serenity.PrefixedContext {
        static formKey = 'CVM.CvmSegment';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!CvmSegmentForm.init)  {
                CvmSegmentForm.init = true;

                var s = Serenity;
                var w0 = s.StringEditor;
                var w1 = s.LookupEditor;
                var w2 = s.BooleanEditor;

                Q.initFormType(CvmSegmentForm, [
                    'Title', w0,
                    'OfferId', w0,
                    'CampaignId', w1,
                    'Criteria', w1,
                    'IsEnabled', w2,
                    'ActionType', w0
                ]);
            }
        }
    }
}
